import { USER_ROLE } from '@/config/constants';

/** Post-auth landing paths by role (Wave 1 IA). */
export function pathForRole(role: USER_ROLE | string, userId?: string): string {
  switch (role) {
    case USER_ROLE.ADMIN:
    case 'admin':
      return '/admin/loan-pipeline';
    case USER_ROLE.SELLER:
    case 'seller':
      return userId ? `/seller/main/${userId}` : '/';
    case USER_ROLE.SELLER_AGENT:
    case 'seller_agent':
      return userId ? `/agent/qualified-contract/${userId}` : '/';
    case USER_ROLE.BUYER:
    case USER_ROLE.USER:
    case 'buyer':
    case 'user':
    default:
      return '/properties';
  }
}

/** Full-page navigate after sign-in / role resolution. */
export function navigateByRole(
  role: USER_ROLE | string,
  userId?: string
): void {
  window.location.href = pathForRole(role, userId);
}

/** @deprecated Use navigateByRole — kept name for call-site clarity during signup. */
export const AuthNavigation = navigateByRole;
